<template>
  <v-expansion-panels v-model="panel" variant="accordion" class="c360-expansion-panels">
    <v-expansion-panel class="c360-expansion-panel" :class="[panel === 0 && 'white']" @click="onPanelClick">
      <v-expansion-panel-header class="c360-expansion-panel-header">
        <c360-navigation-drawer-item
          :key="item.id"
          :item="item"
          :is-active="isActive"
          :is-opened="panel === 0"
          :is-panel-opened="isPanelOpened"
          :open-only-by-expander="openOnlyByExpander"
          has-children
          class="mb-0" 
          @click="$emit('panel-click', $event)"
        />
      </v-expansion-panel-header>
      <v-expansion-panel-content class="c360-expansion-panel-content">
        <div
          v-for="subItem in item.subItems"
          :key="subItem.id"
          class="c360-expansion-panel-content-item-wrapper"
        >
          <c360-navigation-drawer-item
            :item="subItem"
            class="pl-5 mx-2 mb-0"
            :is-active="activeElement == subItem.id"
            @click="$emit('select', subItem)"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import Vue from 'vue';
  import { C360NavigationDrawerItem } from '../../NavigationDrawerItem';

  export default Vue.extend({
    name: 'NavigationDrawerExpansionPanel',

    components: { C360NavigationDrawerItem },

    props: {
      /**
       * Grouped menu items.
       * @type {{ id: string | number; title: string; disabled: boolean; icon?: string; subItems?: [{title: string;}]  }}
       */
      item: {
        type: Object,
        default: () => ({}),
      },

      /**
       * Active element id.
       */
      activeElement: {
        type: String,
        default: '',
      },

      /**
       * Is panel expanded
       */
      isPanelOpened: {
        type: Boolean,
        default: false,
      },

      /**
       * Should menu be opened only by expander.
       */
       openOnlyByExpander: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        panel: null,
      };
    },

    computed: {
      isActive() {
        return this.item.subItems.some((item) => item.id === this.activeElement);
      },
    },

    watch: {
      '$vuetify.application.left'(next, prev) {
        const wrap = prev - next > 0;
        this.panel = wrap ? null : this.panel;
      },
      isPanelOpened(val) {
        if (this.openOnlyByExpander && val && this.isActive) {
          this.panel = 0;
        } 
      },
    },
    methods: {
      onPanelClick() {
        if (this.openOnlyByExpander && this.isPanelOpened === false) {
          this.panel = 0
        }
      },
    },
  });
</script>

<style>
  .c360-expansion-panels .c360-expansion-panel.v-expansion-panel {
    background-color: transparent;
  }

  .c360-expansion-panels .c360-expansion-panel-header {
    padding: 0;
    min-height: auto;
  }

  .c360-expansion-panel-content {
    margin: 0 -8px;
  }

  .c360-expansion-panel-content .v-expansion-panel-content__wrap {
    padding: 0;
  }

  .c360-expansion-panel.v-expansion-panel:before {
    box-shadow: none;
  }
</style>
